import { render, staticRenderFns } from "./MapPolygonControl.vue?vue&type=template&id=487d90ea&"
import script from "./MapPolygonControl.vue?vue&type=script&lang=js&"
export * from "./MapPolygonControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports